export default __webpack_public_path__ + "static/media/ecom1.2b9978dd.svg";